/** Bug #723
 * Midhila Velayudhan
 * 02/02/2022
 */
import { ReactNode } from 'react'
import style from 'components/style/table.module.css';
import { Skeleton, NoResultFound, Card, List, InfiniteScroll, NoMessageFound } from 'components';

declare type Fn = () => any;
declare type FnItem = (item: any, index: any) => any;

interface Props {
    loadMore: Fn,
    totalCount: number,
    list: Array<any>,
    renderItem?: FnItem,
    CoustomList?: ReactNode
    message?: string,
    listProps?: any,
    scrollableTarget?: string,
    styleFromMsg?:boolean
}
const InfiniteScrollLists = ({ loadMore, totalCount, list, renderItem, message, CoustomList = null, listProps = null, scrollableTarget = "primaryLayout", styleFromMsg= false }: Props) => {
    let locale = {
        emptyText: (
            !styleFromMsg ?
             <Card>
                <NoResultFound message={message !== undefined ? message : 'No Data Found'} className={style.noResultFound} />
            </Card> 
            :
             
            <NoMessageFound message={message}  className={style.noResultFoundMsgEmpty}/>                     
        )
    };
    return (
        <InfiniteScroll
            dataLength={list.length}
            next={loadMore}
            hasMore={list.length < totalCount}
            loader={list.length <= 0 ? null : <Skeleton avatar paragraph={{ rows: 1 }} active />}
            scrollableTarget={scrollableTarget}
            style={{ overflowX: 'hidden' }}
        >
            {CoustomList ?
                CoustomList
                :
                <List
                    grid={{ gutter: 16, column: 2, xs: 1, sm: 1, md: 1, lg: 1 }}
                    dataSource={list}
                    locale={locale}
                    renderItem={renderItem}
                    {...listProps}
                />}
        </InfiniteScroll>
    )
}
export default InfiniteScrollLists;